// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b68ec841","186":"4294604c","225":"b1f2a7cc","272":"8fd722fb","372":"e30cc6e2","738":"be52380e","841":"9a19de8e","856":"b2ff55aa"}[chunkId] + ".chunk.js";
};